import React from "react";
import { MenuKey } from "./Menu";
import MenuItem from "./MenuItem/MenuItem";
import useBrandsByLetter from "../../../Hooks/useBrandsByLetter";
import useTopBrands from "../../../Hooks/useTopBrands";

interface IProps {
  active: string | null;
  setActive: React.Dispatch<React.SetStateAction<string | null>>;
  closeSidebar: () => void;
}


const Brands: React.FC<IProps> = ({ active, setActive, closeSidebar }) => {
  const topBrands = useTopBrands();
  const brands = useBrandsByLetter();

  return (
    <>
      {!active && (
        <MenuItem
          text="Brands"
          icon="right"
          onClick={() => {
            setActive(MenuKey.brands);
          }}
        />
      )}

      {active === MenuKey.brands && (
        <>
          <MenuItem
            className="fw-bold"
            text="Brands"
            icon="left"
            onClick={() => setActive(null)}
          />

          {topBrands?.data && (
            <React.Fragment>
              <MenuItem className="fw-bold" text="Top Brands" />
              {topBrands.data.map(({ erp_id, name }) => (
                <MenuItem
                  key={erp_id}
                  text={name}
                  link={`/products?brand_ids=${erp_id}`}
                  onClick={closeSidebar}
                />
              ))}
            </React.Fragment>
          )}

          {brands?.data?.data && (
            <>
              <MenuItem className="fw-bold" text="All Brands" />
              {Object.keys(brands.data.data).map((letter) =>
                brands.data?.data[letter].map((brand) => (
                  <MenuItem
                    key={brand.erp_id}
                    text={brand.name}
                    link={`/products?brand_ids=${brand.erp_id}`}
                    onClick={closeSidebar}
                  />
                ))
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Brands;
